import type { PaletteOptions } from '@mui/material';

type SnackbarType = keyof NonNullable<PaletteOptions['status']>;

export const statusColor: Record<SnackbarType, string> = {
  success: 'status.success',
  error: 'status.error',
  warning: 'status.warning',
  info: 'status.info',
};

export default {
  root: {
    top: { xs: '82px', sm: '100px' },
    right: { xs: 16, sm: 32 },
    left: { xs: 16, sm: 'auto' },
    width: { xs: 'calc(100% - 32px)', sm: 'auto' },
    maxWidth: { xs: 'none', sm: 476 },
    transform: 'none',
    pointerEvents: 'none',
  },
  toast: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: { xs: 1.5, sm: 1 },
    width: { xs: '100%', sm: 476 },
    minHeight: { xs: 64, sm: 64 },
    p: { xs: '14px 14px 14px 18px', sm: '20px 16px' },
    bgcolor: '#fff',
    color: 'grey.600',
    borderRadius: '8px',
    boxShadow: '0px 8px 48px 0px #0000001F',
    overflow: 'hidden',
    pointerEvents: 'auto',
  },
  rail: (type: SnackbarType) => ({
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    width: 4,
    bgcolor: statusColor[type],
  }),
  iconWrap: (type: SnackbarType) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 auto',
    width: 24,
    height: 24,
    borderRadius: '50%',
    bgcolor: statusColor[type],
    color: '#fff',
  }),
  message: {
    flex: 1,
    minWidth: 0,
    fontFamily: 'Manrope',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: 0,
    overflowWrap: 'break-word',
    wordBreak: 'normal',
  },
  closeButton: {
    flex: '0 0 auto',
    width: 24,
    height: 24,
    p: 0,
    color: 'grey.600',
    '&:hover': {
      color: '#000',
      bgcolor: 'transparent',
    },
  },
};
